(function () {
  function getPanel(details) {
    return (
      details.querySelector(':scope > .product-faq__panel') ||
      details.querySelector(':scope > .product-faq__list') ||
      details.querySelector(':scope > .product-faq__answer')
    );
  }

  function animateOpen(details, panel) {
    details.setAttribute('open', '');
    panel.style.height = '0px';
    panel.style.opacity = '0';
    panel.style.overflow = 'hidden';

    requestAnimationFrame(function () {
      panel.style.transition = 'height 0.35s ease, opacity 0.3s ease';
      panel.style.height = panel.scrollHeight + 'px';
      panel.style.opacity = '1';
    });

    function onEnd(event) {
      if (event.propertyName !== 'height') return;
      panel.style.height = 'auto';
      panel.style.overflow = '';
      panel.removeEventListener('transitionend', onEnd);
    }

    panel.addEventListener('transitionend', onEnd);
  }

  function animateClose(details, panel) {
    panel.style.height = panel.scrollHeight + 'px';
    panel.style.opacity = '1';
    panel.style.overflow = 'hidden';

    requestAnimationFrame(function () {
      panel.style.transition = 'height 0.3s ease, opacity 0.25s ease';
      panel.style.height = '0px';
      panel.style.opacity = '0';
    });

    function onEnd(event) {
      if (event.propertyName !== 'height') return;
      details.removeAttribute('open');
      panel.style.height = '';
      panel.style.opacity = '';
      panel.style.overflow = '';
      panel.style.transition = '';
      panel.removeEventListener('transitionend', onEnd);
    }

    panel.addEventListener('transitionend', onEnd);
  }

  function enhanceDetails(details) {
    var summary = details.querySelector(':scope > summary');
    var panel = getPanel(details);
    if (!summary || !panel || details.dataset.faqAnimated === 'true') return;

    details.dataset.faqAnimated = 'true';

    summary.addEventListener('click', function (event) {
      event.preventDefault();

      if (details.open) {
        animateClose(details, panel);
      } else {
        animateOpen(details, panel);
      }
    });
  }

  function init(root) {
    if (!root) return;
    root.querySelectorAll('details').forEach(enhanceDetails);
  }

  function boot() {
    document.querySelectorAll('.product-faq').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function (event) {
    var root = event.target && event.target.querySelector
      ? event.target.querySelector('.product-faq')
      : null;
    init(root || event.target);
  });
})();
